import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space2, colorBgBase } = theme();

  const radius = space2;

  return StyleSheet.create({
    dot: {
      backgroundColor: colorBgBase,
      borderRadius: radius / 2,
      cursor: "pointer",
      height: radius,
      width: radius,
    },
  });
};

export { style };
